import type { SkillBuilderConfiguration } from "~skillBuilder/utils/types";

import {
  AzMrtAbuse,
  AzMrtFeedback,
  AzMrtLegal,
  AzMrtOverview,
  AzMrtReporting,
  AzMrtSkillCheck,
  AzMrtSubstitute,
} from "../swing/azMrt";

export const GLENDALE_DISTRICT_ID = "5db1d25a-a175-4927-9224-b4cc1e317e7f";

export const GlendaleDistrictConfiguration: SkillBuilderConfiguration = {
  version: "glendale-district",
  groups: [
    {
      isCustom: true,
      name: "Arizona Mandated Reporter Training (AZ Subs Only)",
      tasks: [
        // Task #1
        AzMrtOverview,
        // Task #2
        AzMrtLegal,
        // Task #3
        AzMrtAbuse,
        // Task #4
        AzMrtReporting,
        // Task #5
        AzMrtSubstitute,
        // Task #6
        AzMrtSkillCheck as any,
      ],
      feedback: AzMrtFeedback as any,
    },
  ],
};
